<template>
  <div class="content">
    <div class="md-layout md-alignment-center-center">
      <div
        class="md-layout-item md-xlarge-size-75 md-large-size-100 md-small-size-100 md-xsmall-size-100"
      >
        <md-card>
          <md-card-header data-background-color="secondary">
            <h4 class="title">Safety Notices</h4>
            <p class="category">Find the latest safety notices here</p>
          </md-card-header>
          <md-card-content>
            <md-table
              v-model="notices"
              md-sort="order_id"
              md-sort-order="asc"
              table-header-color="primary"
            >
              <md-table-empty-state
                md-label="No records found"
                :md-description="
                  `No records found for this '${search}' query. Try a different search term.`
                "
              />

              <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell md-label="Published Date" md-sort-by="date">{{
                  item.date
                }}</md-table-cell>
                <md-table-cell md-label="Description">
                  <strong>{{ item.title }}</strong>
                  <br />{{ item.description }}
                </md-table-cell>
                <md-table-cell md-label="View" class="align-left">
                  <router-link :to="item.url" target="_blank"
                    >View/Download</router-link
                  >
                </md-table-cell>
              </md-table-row>
            </md-table>
          </md-card-content>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      search: null,
      searched: [],
      notices: [
        {
          id: 123,
          date: "01-01-2021",
          title: "Children in the Workplace",
          description:
            "With School Holidays commencing next week, Sydney Markets Limited would like to remind all tenants that children who attend the Market during Wholesale and Retail Market operating hours must be supervised at all times.",
          url: "/download"
        }
      ]
    };
  }
};
</script>
